export default {
    getOnboardingEmail(state) {
        return state.email;
    }
}
